<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="tw-flex tw-flex-col tw-bg-white tw-rounded-xl"
  [ngClass]="{'max-md:tw-max-h-[355px] tablet:tw-max-h-[300px]':isFromCompleteCampaignDialog}">
  <input type="file" class="tw-hidden" #fileInput multiple (change)="handleFileInput($event)"
    [accept]="allowedFileTypes" />
  @if(!inDonorTable){
  @if(!fromCampaignDesign && !fromAiCampaignDesign){
  <div
    class="tw-border tw-border-dashed tw-border-primary-500 tw-rounded-xl tw-text-grey-750 tw-py-6 tw-px-3 tw-flex tw-flex-col tw-justify-center tw-items-center tw-cursor-pointer"
    (drop)="onDrop($event)" (dragover)="onDragOver($event)" (click)="fileInput.click()">
    <i-icon [name]="'camera'" class="!tw-w-20 !tw-h-20"></i-icon>
    <div class="tw-font-medium tw-text-sm tw-text-center tw-leading-[22px] tablet:tw-text-base">
      {{ strings.BROWSE_FILES_TEXT }}
      <span class="tw-font-bold tw-text-primary-700" id="browse">
        {{ strings.CHOOSE_FILE }}
      </span>
    </div>
    <div class="tw-font-normal tw-text-xs tw-leading-[18px] tw-text-center">
      {{ strings.FILE_FORMAT_TEXT }}
      {{ acceptedFileTypes.join(', ') }}
    </div>
    <div class="tw-font-normal tw-text-xs tw-leading-[18px] tw-text-center">
      {{ strings.UPLOAD_LIMIT_TEXT }}
    </div>
  </div>
  }
  @else if (fromCampaignDesign) {
  <div class="tw-w-full tw-border tw-rounded-xl tw-border-[#E3E3E3] tw-py-3 tw-cursor-pointer" [ngClass]="{'max-[760px]:tw-px-6':isFromCompleteCampaignDialog}" (drop)="onDrop($event)"
    (dragover)="onDragOver($event)" (click)="fileInput.click()">
    <div class="tw-text-center tw-text-primary-700 tablet:tw-text-base max-md:tw-text-[14px] tw-leading-[24px]" [ngClass]="{'max-[760px]:tw-text-[16px]':isFromCompleteCampaignDialog}" >
      <span class="tw-font-bold">Click to add {{isCampaignDocument ? 'documents' : 'photos'}}:</span> or drag and drop
      photos here

    </div>
  </div>
  @if (showPhotoLibrary) {
  <div class="tw-flex tw-pt-3">
    <button smlButton="primary" [size]="'sm'" type="button" class="tw-h-10 tw-gap-2"
      (click)="openPhotoLibrary()">
      <i-icon [name]="'image'" class="!tw-w-[20px] !tw-h-[20px]"></i-icon>
      {{ strings.PHOTO_LIBRARY_BUTTON }}
    </button>
  </div>
  }
  }
  @else if (fromAiCampaignDesign) {
  <div class="tw-w-full tw-bg-[#F8F8F8] tw-border tw-border-dashed tw-border-[#E3E3E3] tw-rounded-xl tw-py-3 tw-px-6 tw-flex tw-items-center tw-justify-center tw-cursor-pointer"
    (drop)="onDrop($event)" (dragover)="onDragOver($event)" (click)="fileInput.click()">
    <p class="tw-text-xs tw-leading-[18px] tw-text-[#041519] tw-text-center tw-m-0">
      <span class="tw-font-bold">Add {{isCampaignDocument ? 'File' : 'photos'}}:</span>
      <span class="tw-font-normal"> or </span>
      <span class="tw-font-normal tw-text-[#106B8E] tw-underline">browse library</span>
    </p>
  </div>
  }
  <div class="tw-font-medium tw-text-[10px] tw-leading-4 tw-text-mercury-600 tw-pt-[22px] tablet:tw-pt-8"
    *ngIf="isGalleryView && imagePreviewListBlob.length && !oneFileOnly() && !isFromCompleteCampaignDialog">
    {{ strings.REARRANGE_TEXT }}
  </div>

  @if(!isFromCompleteCampaignDialog){
  <div class="tw-grid" [ngClass]="{
      'tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-2 md:tw-gap-3': isGalleryView,
      'tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-2.5 md:tw-gap-4': !isGalleryView,
      'tw-pt-2': isGalleryView && imagePreviewListBlob.length > 0,
      'tw-pt-5': !isGalleryView && imagePreviewListBlob.length > 0,
      'tw-bg-[#F8F8F8]': isCampaignDocument && !fromAiCampaignDesign
    }"
  
    cdkDropList
    cdkDropListOrientation="mixed"
    (cdkDropListDropped)="drop($event)"
  >
  @for (image of imagePreviewListBlob; track image.Id; let i = $index) {
    <div class="{{imageSize}}"

      [ngClass]="
        isGalleryView
          ? 'tw-relative tw-w-full tw-max-w-[160px] tw-h-[160px] tablet:tw-max-w-[210px] tablet:tw-h-[210px]'
          : 'tw-relative'
      "
      cdkDrag
    >
      <ng-container *ngIf="isGalleryView">
        <img
          [src]="image.BlobUrl"
          alt="Image Preview"
          class="tw-w-full tw-h-full tw-object-cover tw-rounded-lg"
        />
        <div
          *ngIf="image.size"
          class="tw-font-medium tw-text-[8px] tw-leading-[8px] tablet:tw-text-[10px] tablet:tw-leading-4 tw-bg-dark-grey tw-text-white tw-py-1 tw-px-2 tw-rounded-lg tw-w-max tw-absolute tw-bottom-2 tw-left-2"
        >
        <div class="tw-flex tw-gap-1 tw-items-center">
          <button type="button" (click)="downloadImage(image.BlobUrl,image.Name)">
            <i-icon [name]="'download'" class="!tw-w-4 !tw-h-4"></i-icon>
          </button>

          <div>
            {{ image.size }}
          </div>
        </div>
        </div>
        <div *ngIf="image.isTemporaryUrl" class="tw-w-full tw-h-full tw-absolute tw-rounded-lg tw-top-0 tw-z-[2]">
          <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'sm'" [loaderClass]="''"></sml-spinner>
        </div>
      </ng-container>
      <div *ngIf="!isGalleryView" class="tw-sml-border tw-rounded-lg tw-cursor-pointer">
        <ng-container [ngSwitch]="true">
          <div *ngSwitchCase="imageExtensions.includes(image.Extension)"
            class="tw-w-full tw-h-[94px] tw-rounded-t-lg tw-bg-grey-250">
            <img [src]="image.BlobUrl" alt="card image" class="tw-rounded-t-lg tw-h-[94px] tw-w-full tw-object-cover" />
            <div *ngIf="image.isTemporaryUrl" class="tw-w-full tw-h-full tw-absolute tw-rounded-lg tw-top-0">
              <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'sm'" [loaderClass]="''"></sml-spinner>
            </div>
          </div>
          <div *ngSwitchDefault
            class="tw-w-full tw-h-[94px] tw-rounded-t-lg tw-bg-grey-250 tw-flex tw-justify-center tw-items-center">
            <i-icon [name]="getIconNames(image.Extension)" class="!tw-w-10 !tw-h-[52px]"></i-icon>
            <div *ngIf="image.isTemporaryUrl" class="tw-w-full tw-h-full tw-absolute tw-rounded-lg tw-top-0 tw-z-[2]">
              <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'sm'" [loaderClass]="''"></sml-spinner>
            </div>
          </div>
        </ng-container>

        <div class="tw-py-3 tw-px-3 tw-bg-white tw-rounded-b-[8px]">
          <div smlTooltip="{{ image.Name }}"
            class="tw-text-xs tw-leading-[18px] tw-font-bold tw-text-grey-850 tw-truncate" id="card-name-{{ i }}">
            {{ image.Name }}
          </div>

          <div *ngIf="image.size"
            class="tw-font-medium tw-text-[6px] tw-leading-[8px] tablet:tw-text-[8px] tablet:tw-leading-4 tw-bg-dark-grey tw-text-white tw-py-1 tw-px-2 tw-rounded-lg tw-w-max">
            <div class="tw-flex tw-gap-1 tw-items-center">
              <button type="button" (click)="downloadImage(image.BlobUrl,image.Name)">
                <i-icon [name]="'download'" class="!tw-w-3 !tw-h-3"></i-icon>
              </button>

              <div>
                {{ image.size }}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div
        class="tw-absolute tw-top-2 tw-left-2 tw-bg-dark-grey tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-justify-center tw-items-center"
        *ngIf="image.size && !oneFileOnly()">
        <i-icon [name]="'resize-double'" class="!tw-w-5 !tw-h-5 tw-cursor-grab tw-text-white" cdkDragHandle></i-icon>
      </div>
        <button type="button" *ngIf="isImageFile(image)"
          class="tw-bg-black tw-absolute tw-p-1 tw-bottom-[10px] !tw-text-white tw-right-[8px] tw-flex tw-p-[3px] tw-rounded-full tw-border-0 tw-outline-none" smlTooltip="Preview">
          <i-icon (click)="openLightbox(i)" [name]="'preview-icon'"
            class="!tw-w-[20px] !tw-h-[20px] hover:tw-cursor-pointer !tw-text-white"></i-icon>
        </button>
      <div
        class="tw-bg-dark-grey tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-justify-center tw-items-center tw-absolute tw-top-2 tw-right-2 tw-cursor-pointer"
        (click)="removeImage(i)">
        <i-icon [name]="'trash'" class="!tw-w-5 tablet:!tw-h-5 tw-text-white"></i-icon>
      </div>

    </div>
    }
  </div>
  }

  @if(isFromCompleteCampaignDialog){
  <div class="tw-grid tw-max-h-[350px] tw-overflow-y-scroll" [ngClass]="{
      'tw-grid-cols-2 md:tw-grid-cols-3 tw-gap-2 md:tw-gap-3': isGalleryView,
      'tw-grid-cols-3 md:tw-grid-cols-4 tw-gap-2.5 md:tw-gap-4': !isGalleryView,
      'tw-my-3': isGalleryView && imagePreviewListBlob.length > 0,
      'tw-pt-5': !isGalleryView && imagePreviewListBlob.length > 0,
      'tw-bg-[#F8F8F8]': isCampaignDocument
    }" cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="drop($event)">
    @for (image of imagePreviewListBlob; track image.Id; let i = $index) {
    <div class="{{imageSize}}" [ngClass]="
        isGalleryView
          ? 'tw-relative tw-w-[155px] tw-h-[130px]'
          : 'tw-relative'
      " cdkDrag>
      <ng-container *ngIf="isGalleryView">
        <img [src]="image.BlobUrl" alt="Image Preview" class="tw-w-full tw-h-full tw-object-cover tw-rounded-lg" />
        <div *ngIf="image.size"
          class="tw-font-medium tw-text-[8px] tw-leading-[8px] tablet:tw-text-[10px] tablet:tw-leading-4 tw-bg-dark-grey tw-text-white tw-py-1 tw-px-2 tw-rounded-lg tw-w-max tw-absolute tw-bottom-2 tw-left-2">
          <div class="tw-flex tw-gap-1 tw-items-center">
            <button type="button" (click)="downloadImage(image.BlobUrl,image.Name)">
              <i-icon [name]="'download'" class="!tw-w-4 !tw-h-4"></i-icon>
            </button>

            <div>
              {{ image.size }}
            </div>
          </div>
        </div>
        <div *ngIf="image.isTemporaryUrl" class="tw-w-full tw-h-full tw-absolute tw-rounded-lg tw-top-0 tw-z-[2]">
          <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'sm'" [loaderClass]="''"></sml-spinner>
        </div>
      </ng-container>
      <div *ngIf="!isGalleryView" class="tw-sml-border tw-rounded-lg tw-cursor-pointer">
        <ng-container [ngSwitch]="true">
          <div *ngSwitchCase="imageExtensions.includes(image.Extension)"
            class="tw-w-full tw-h-[94px] tw-rounded-t-lg tw-bg-grey-250">
            <img [src]="image.BlobUrl" alt="card image" class="tw-rounded-t-lg tw-h-[94px] tw-w-full tw-object-cover" />
            <div *ngIf="image.isTemporaryUrl" class="tw-w-full tw-h-full tw-absolute tw-rounded-lg tw-top-0">
              <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'sm'" [loaderClass]="''"></sml-spinner>
            </div>
          </div>
          <div
            *ngSwitchDefault
            class="tw-w-full tw-h-[94px] tw-rounded-t-lg tw-bg-grey-250 tw-flex tw-justify-center tw-items-center"
          >
            <i-icon
              [name]="getIconNames(image.Extension)"
              class="!tw-w-10 !tw-h-[52px]"
            ></i-icon>
            <div *ngIf="image.isTemporaryUrl" class="tw-w-full tw-h-full tw-absolute tw-rounded-lg tw-top-0 tw-z-[2]">
              <sml-spinner [type]="'spinner'" [isGlobal]="false" [size]="'sm'" [loaderClass]="''"></sml-spinner>
            </div>
          </div>
        </ng-container>

        <div class="tw-py-3 tw-px-3 tw-bg-white tw-rounded-b-[8px]">
          <div
            smlTooltip="{{ image.Name }}"
            class="tw-text-xs tw-leading-[18px] tw-font-bold tw-text-grey-850 tw-truncate"
            id="card-name-{{ i }}"
          >
            {{ image.Name }}
          </div>
          
          <div
          *ngIf="image.size"
          class="tw-font-medium tw-text-[6px] tw-leading-[8px] tablet:tw-text-[8px] tablet:tw-leading-4 tw-bg-dark-grey tw-text-white tw-py-1 tw-px-2 tw-rounded-lg tw-w-max"
        >
        <div class="tw-flex tw-gap-1 tw-items-center">
          <button type="button" (click)="downloadImage(image.BlobUrl,image.Name)">
            <i-icon [name]="'download'" class="!tw-w-3 !tw-h-3"></i-icon>
          </button>

          <div>
            {{ image.size }}
          </div>
        </div>
        </div>
          
        </div>
      </div>
      <div class="tw-absolute tw-top-2 tw-left-2 tw-bg-dark-grey tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-justify-center tw-items-center" *ngIf="image.size && !oneFileOnly()">
        <i-icon
        [name]="'resize-double'"
        class="!tw-w-5 !tw-h-5 tw-cursor-grab tw-text-white"
        cdkDragHandle

      ></i-icon>
      </div>

      <div
        class="tw-bg-dark-grey tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-justify-center tw-items-center tw-absolute tw-top-2 tw-right-2 tw-cursor-pointer"
        (click)="removeImage(i)"
      >
        <i-icon
          [name]="'trash'"
          class="!tw-w-5 tablet:!tw-h-5 tw-text-white"
        ></i-icon>
      </div>
      
    </div>
    }
  </div>
  }
  }
  @else{
  <div class="tw-flex tw-flex-col tw-gap-2 ">

    <div class="tw-flex tw-flex-col tw-gap-2 ">
      @for (image of imagePreviewListBlob; track image.Id; let i = $index)
      {
      <div class="tw-flex tw-flex-row tw-gap-2 tw-items-center">
        <div
          class="tw-flex tw-flex-row tw-gap-3 tw-py-3 tw-px-6 tw-w-full tw-border tw-rounded-xl tw-border-mercury-200 tw-items-center ">
          <i-icon [name]="getIconNames(image.Extension)" class="!tw-w-[14px] !tw-h-3"></i-icon>

          <div
            class="tw-font-bold tw-text-sm tw-leading-6 tw-underline tw-truncate tablet:!tw-max-w-[300px] max-md:!tw-max-w-[250px] tw-cursor-pointer"
            (click)="openDocumentPreview(i)" smlTooltip="{{ image.Name }}">
            {{ image.Name }}
          </div>
        </div>
        <button type="button" *ngIf="image.IsUserUploadedFile"
          class="tw-p-0 tw-bg-transparent tw-border-0 tw-outline-none">
          <i-icon (click)="removeImage(i)" [name]="fromActivitylog?'activity-log-delete':'trash-outline'"
            class="!tw-w-[20px] !tw-h-[20px] hover:tw-cursor-pointer"></i-icon>
        </button>
      </div>

      }
    </div>
    <div class="tw-w-full tw-border tw-rounded-xl tw-border-mercury-200 tw-py-3 tw-px-6 hover:tw-cursor-pointer"
      (drop)="onDrop($event)" (dragover)="onDragOver($event)" (click)="fileInput.click()">


      <div class="tw-flex tw-flex-row tw-gap-3">
        <div>
          <i-icon [name]="'cloud-upload'" class="!tw-w-[25px] !tw-h-[25px]"></i-icon>
        </div>
        <div class="tw-text-base tw-font-normal tw-text-[#828485]">
          <span class="tw-font-bold">Browse Files: </span>Drag and drop files here
        </div>
      </div>
    </div>
  </div>

  }
</div>

@if (showPhotoLibrary) {
<sml-stock-image-picker [isOpen]="isPhotoLibraryOpen" [allowMultiple]="!oneFileOnly()"
  [aspectRatio]="photoAspectRatio" [context]="photoLibraryContext"
  [campaignType]="photoLibraryCampaignType" (photosPicked)="onPhotosPickedFromLibrary($event)"
  (closed)="closePhotoLibrary()"></sml-stock-image-picker>
}